import { PersonnelUsersUIProvider } from "./PersonnelUsersUIContext";
import { PersonnelUsersCard } from "./PersonnelUsersCard";

export function PersonnelUsersPage() {
  return (
    <PersonnelUsersUIProvider>
      <PersonnelUsersCard />
    </PersonnelUsersUIProvider>
 );
}